
import React from 'react';
import { Spin, Icon } from 'antd';

export default class PageWrap extends React.Component {

    render() {
        let { loading=false } = this.props;

        return (
            <div style={{ width: '100%', overflowY: 'auto', flex: 1, boxSizing: 'border-box', background: '#fff', border: '1px solid #e8e8e8', borderTop: 'none' }}>
                <Spin
                    spinning={loading}
                    wrapperClassName={"pageWrap"}
                    indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}
                >
                    <div style={{ padding: '0 20px 20px' }}>{this.props.children}</div>
                </Spin>
                <style>
                    {`
                        .pageWrap {
                            width: 100%;
                            height: calc(100% - 20px);
                            box-sizing: border-box;
                        }
                    `}
                </style>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/PageWrap/index.js